import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from './TemplateHeader7.module.css';
import { FaBars, FaTimes } from 'react-icons/fa';
import { useAuth } from '../../Common/Configurations/AuthContext';

const TemplateHeader7 = ({ branding, mode, templateId, headerMenu = [], onNavigate }) => {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { user } = useAuth();

  const logoUrl = branding?.logoUrl || user?.logo;
  const companyName = branding?.companyName || user?.companyName || "Travel Agency";
  const brandName = branding?.brandName || user?.brandName || "Travel Agency";

  const handleNavClick = (e, item) => {
    const viewName = item.path === "/" ? "home" : item.path.replace('/', '');

    // BUILDER MODE
    if (mode === "builder") {
      e.preventDefault();
      onNavigate({ name: viewName, params: null });
    }
    // PREVIEW MODE
    else if (mode === "preview") {
      e.preventDefault();
      navigate(`/template-preview/${templateId}/${viewName}`);
    }
    // LIVE MODE
    else {
      // Let Link work normally
    }

    setIsMobileMenuOpen(false);
  };

  return (
    <header className={styles.header}>
      <div className={styles.outerContainer}>
        <div className={styles.glassLayer}>
          <div className={styles.container}>

            <div className={styles.logoContainer}>
             <Link
  to="/"
  onClick={(e) => {
    e.preventDefault(); // 🔥 stops navigation
    handleNavClick(e, { path: "/" });
  }}
>
                {logoUrl ? (
                  <img src={logoUrl} alt={brandName} className={styles.logoImage} />
                ) : (
                  <h2 className={styles.textLogo}>{brandName}</h2>
                )}
              </Link>
            </div>

            <div className={styles.rightSection}>

              <nav className={`${styles.nav} ${isMobileMenuOpen ? styles.navOpen : ''}`}>
                <ul className={styles.navList}>
                  {headerMenu.map((item) => (
                    <li key={item.id} className={styles.navItem}>
                      <Link
                        to={item.path}
                        onClick={(e) => handleNavClick(e, item)}
                        className={styles.navLink}
                      >
                        {item.label}
                        <span className={styles.dot}></span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </nav>

              <div className={styles.ctaContainer}>
                <button className={styles.bookBtn}>Book Now</button>
              </div>

              <div
                className={styles.mobileToggle}
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              >
                {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
              </div>

            </div>

          </div>
        </div>
      </div>
    </header>
  );
};

export default TemplateHeader7;